export enum EJsonQueryType {
  Term = 'term',
  Terms = 'terms',
}
export interface IJsonQueryTerm<T> {
  type: EJsonQueryType.Term;
  value: T;
}

export interface IJsonQueryTerms<T> {
  type: EJsonQueryType.Terms;
  value: T[];
}
